import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  console.log('PrivateRoute - isAuthenticated:', isAuthenticated); // Debug log
  
  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login'); // Debug log
    return <Navigate to="/login" replace />;
  }
  
  console.log('Authenticated, rendering children'); // Debug log
  return children;
};
export default PrivateRoute;